import React from "react";
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Facebook,
  Instagram,
  Twitter,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-purple-950 text-purple-200 py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h5 className="text-white text-xl font-medium mb-6">
              About Ambaari Jewels
            </h5>
            <p className="mb-6 leading-relaxed">
              Discover exquisite jewelry crafted with passion and precision at
              Ambaari Jewels. We bring you timeless designs that celebrate
              traditional craftsmanship with modern aesthetics.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="hover:text-purple-100 transition-colors duration-200"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a
                href="#"
                className="hover:text-purple-100 transition-colors duration-200"
              >
                <Instagram className="w-6 h-6" />
              </a>
              <a
                href="#"
                className="hover:text-purple-100 transition-colors duration-200"
              >
                <Twitter className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-white text-xl font-medium mb-6">Quick Links</h5>
            <ul className="space-y-4">
              <li>
                <a
                  href="#"
                  className="hover:text-purple-100 transition-colors duration-200 flex items-center gap-2"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-purple-100 transition-colors duration-200 flex items-center gap-2"
                >
                  Our Legacy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-purple-100 transition-colors duration-200 flex items-center gap-2"
                >
                  Shipping Policy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-purple-100 transition-colors duration-200 flex items-center gap-2"
                >
                  FAQs
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-purple-100 transition-colors duration-200 flex items-center gap-2"
                >
                  Blogs
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h5 className="text-white text-xl font-medium mb-6">Contact Us</h5>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-6 h-6 mt-1 flex-shrink-0 text-purple-300" />
                <p>
                  Ambaari jewels, # 34, Ground Floor, Shop No.4, LIC layout,
                  Opp. century Indus Apartment, R R Nagar, Bangalore - 560098
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-6 h-6 text-purple-300" />
                <a href="tel:+918660891204" className="hover:text-purple-100">
                  +91 8660891204
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-6 h-6 text-purple-300" />
                <a
                  href="mailto:ambaarijewels@gmail.com"
                  className="hover:text-purple-100"
                >
                  ambaarijewels@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-6 h-6 text-purple-300" />
                <p>Mon - Sun: 10:00 AM - 8:00 PM</p>
              </div>
            </div>

            {/* Map */}
            <div className="mt-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.9372206442363!2d77.5106545!3d12.9117565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3f11ad535177%3A0xc99fbef483ce0f4f!2sKrish%20Interiors!5e0!3m2!1sen!2sin!4v1740318019808!5m2!1sen!2sin"
                className="w-full h-48 rounded-lg border-2 border-purple-800"
                loading="lazy"
                title="Store Location"
              />
              
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-purple-900 text-center">
          <p>
            &copy; {new Date().getFullYear()} Ambaari Jewels. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
